<template>
  <v-select
    :items="highlights"
    item-value="key"
    item-text="name"
    label="Настройки подсветки"
    dense
    hide-details
    outlined
    :menu-props="{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    }"
    single-line
    class="py-2 px-0"
    @change="changed"
    v-model="selected"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: [],
      highlights: [
        { key: "", name: "" },
        { key: "1:1 F", name: "Фаталити" },
        { key: "1:0 F", name: "Фаталити слева" },
        { key: "0:1 F", name: "Фаталити справа" },
        { key: "1:1 B", name: "Бруталити" },

        { key: "1:0 B", name: "Бруталити слева" },
        { key: "0:1 B", name: "Бруталити справа" },
        { key: "5:", name: "П1" },
        { key: ":5", name: "П2" },
        { key: "out", name: "Аутсайдер" },
        { key: "fav", name: "Фаворит" },
        { key: "win", name: "Победитель" },
        // { key: "R", name: "Hand" },
      ],
    };
  },
  methods: {
    ...mapGetters(["getSettings"]),
    ...mapActions(["addHighlight"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.addHighlight({ type: "fighters", value: this.selected });
    },
  },
  created() {
    let settings = this.getSettings().highlights;
    if (settings.fighters == "") {
      return;
    }
    let value = settings.fighters;
    this.selected = this.highlights;
    for (const item of this.highlights) {
      if (item.key == value) this.selected = value;
    }
  },
};
</script>

<style scoped></style>
